export default "__VITE_ASSET__DVdq$Xb___"